import { ResourceObjectInsurance } from "../types"

export function useInsuranceFilter(insurances: ResourceObjectInsurance[]) {
  const activePrivateInsurances = React.useMemo(() => {
    const now = new Date()
    return insurances.filter(
      (i) => i.isPrivateInsurance && (!i.endDate || new Date(i.endDate) > now)
    )
  }, [insurances])

  const activeBusinessInsurances = React.useMemo(() => {
    const now = new Date()
    return insurances.filter(
      (i) => !i.isPrivateInsurance && (!i.endDate || new Date(i.endDate) > now)
    )
  }, [insurances])

  const historyPrivateInsurances = React.useMemo(() => {
    const now = new Date()
    return insurances.filter(
      (i) => i.isPrivateInsurance && i.endDate && new Date(i.endDate) <= now
    )
  }, [insurances])

  const historyBusinessInsurances = React.useMemo(() => {
    const now = new Date()
    return insurances.filter(
      (i) => !i.isPrivateInsurance && i.endDate && new Date(i.endDate) <= now
    )
  }, [insurances])

  return {
    activePrivateInsurances,
    activeBusinessInsurances,
    historyPrivateInsurances,
    historyBusinessInsurances,
  }
}
